//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const workSubmittingSlice = createSlice({
    name: 'workSubmittingSlc',
    initialState: {value: {
            submitting: false
        }},
    reducers:
        // {
        //     changeWorkSubmitting: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
    changeWorkSubmitting: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeWorkSubmitting } = workSubmittingSlice.actions;

export default  workSubmittingSlice.reducer ;
